"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vuex_1 = require("vuex");
const vuelidate_1 = require("vuelidate");
const validators_1 = require("vuelidate/lib/validators");
const Login_1 = tslib_1.__importDefault(require("../models/Login"));
const jwt_1 = tslib_1.__importDefault(require("../tools/jwt"));
exports.default = {
    mixins: [vuelidate_1.validationMixin],
    validations: {
        model: {
            password: {
                required: validators_1.required,
            },
            email: {
                required: validators_1.required,
                email: validators_1.email,
            },
        },
    },
    data: () => ({
        model: new Login_1.default(),
        errorMessage: '',
    }),
    computed: {
        emailErrors() {
            const errors = [];
            if (!this.$v.model.email.$dirty) {
                return errors;
            }
            if (!this.$v.model.email.email) {
                errors.push(this.trans('v_email_email'));
            }
            if (!this.$v.model.email.required) {
                errors.push(this.trans('v_email_required'));
            }
            return errors;
        },
        passwordErrors() {
            const errors = [];
            if (!this.$v.model.password.$dirty) {
                return errors;
            }
            if (!this.$v.model.password.required) {
                errors.push(this.trans('v_password_required'));
            }
            if (this.errorMessage) {
                errors.push(this.trans('v_password_valid'));
            }
            return errors;
        },
    },
    methods: Object.assign(Object.assign({}, vuex_1.mapActions(['setUser'])), { login() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                this.$v.$touch();
                if (this.$v.$error) {
                    return;
                }
                const { accessToken, refreshToken, user } = yield this.model.submit();
                this.saveTokens(accessToken, refreshToken);
                this.setUser(user);
            });
        },
        saveTokens(accessToken, refreshToken) {
            jwt_1.default.storageSet(jwt_1.default.tokenName, accessToken);
            jwt_1.default.storageSet(jwt_1.default.refreshTokenName, refreshToken);
        } }),
};
//# sourceMappingURL=login.js.map